import { makeStyles } from '@material-ui/styles'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import DropdownField from 'core/components/validatedForm/DropdownField'
import TextField from 'core/components/validatedForm/TextField'
import AsyncDropdown from 'core/elements/dropdown/AsyncDropdown'
import VirtualMachineFlavorsTable from './VirtualMachineFlavorsTable'

import React from 'react'
import StorageVolumesField from './StorageVolumesField'

const NETWORK_SUBNET_OPTIONS = [
  { label: 'vm-network (a.b.c.d/24)', value: 'vm-network' },
  { label: 'storage-network (m.n.o.p/24)', value: 'storage-network' },
]

const NETWORK_ACCESS_OPTIONS = [
  { label: 'Trusted Sources Only', value: 'trustedOnly' },
  { label: 'Unrestricted', value: 'unrestricted' },
]

const STORAGE_CLASS_OPTIONS = [
  { label: 'Tier1-NetApp (30 / 50 GB avilable', value: 'netapp' },
  { label: 'Tier2 LVM (80 / 100 GB available', value: 'lvm' },
]

export default function({ configs, vmFlavors, params, getParamsUpdater }) {
  const classes = useStyles()

  return (
    <div className={classes.capacityFields}>
      <DropdownField
        id="configuration"
        label="Configuration"
        DropdownComponent={AsyncDropdown}
        items={configs}
        value={params.replicas}
        onChange={(value) => getParamsUpdater('replicas')(value)}
        selectFirst
        required
      />
      <VirtualMachineFlavorsTable
        data={vmFlavors}
        selectedItems={params.flavor ? [params.flavor] : []}
        onChange={(value) => getParamsUpdater('flavor')(value[0])}
      />
      <div className={classes.subsection}>
        <Text variant="subtitle2">Additional Storage Volume</Text>
        <StorageVolumesField
          volumes={params.storageVolumes}
          storageClassOptions={STORAGE_CLASS_OPTIONS}
          onChange={(value) => getParamsUpdater('storageVolumes')(value)}
        />
      </div>
      <div className={classes.subsection}>
        <Text variant="subtitle2">Network and Security</Text>
        <DropdownField
          id="network"
          label="Network/Subnet"
          DropdownComponent={AsyncDropdown}
          items={NETWORK_SUBNET_OPTIONS}
          value={params.network}
          onChange={(value) => getParamsUpdater('network')(value)}
          selectFirst
          required
        />
        <div className={classes.row}>
          <DropdownField
            id="networkAccess"
            label="Network Access"
            DropdownComponent={AsyncDropdown}
            items={NETWORK_ACCESS_OPTIONS}
            value={params.networkAccess}
            onChange={(value) => getParamsUpdater('networkAccess')(value)}
            selectFirst
            required
          />
          {params.networkAccess === 'trustedOnly' && (
            <TextField
              id="trustedSources"
              label="Trusted Sources"
              value={params.trustedSources}
              onChange={(value) => getParamsUpdater('trustedSources')(value)}
              required
            />
          )}
        </div>
      </div>
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  capacityFields: {
    display: 'grid',
    gridGap: theme.spacing(4),
  },
  subsection: {
    display: 'grid',
    gridGap: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    paddingTop: theme.spacing(4),
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
  },
}))
